import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { useDesktop } from '../useDesktop';

export interface SimulationPropertyProps {
  name: ReactNode;
  value: ReactNode;
}

const SimulationProperty = ({ name, value }: SimulationPropertyProps) => {
  const isDesktop = useDesktop();

  return (
    <span>
      <Typography component="span" color="text.primary" variant={isDesktop ? 'subtitle1' : 'body1'}>
        {name}:
      </Typography>{' '}
      <Typography
        color="text.secondary"
        component="span"
        sx={{ whiteSpace: 'nowrap' }}
        variant={isDesktop ? 'subtitle1' : 'body1'}
      >
        {value}
      </Typography>
    </span>
  );
};

export default SimulationProperty;
